var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_vm._l((_vm.fragmentedString),function(fragment,idx){return [(typeof fragment === 'string')?_c('span',{key:idx,domProps:{"innerHTML":_vm._s(fragment)}}):_c('router-link',{key:idx,attrs:{"to":_vm.to(fragment.erratum)}},[_vm._v(_vm._s(fragment.text))])]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }